import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type OrganisationSupplierItem = ResultOf<
  typeof organisationSuppliersQuery
>["suppliers"]["data"][number];

export const organisationSuppliersQuery = graphql(`
  query OrganisationSuppliers($managed_by_id: ID, $first: Int!, $page: Int) {
    suppliers(
      managed_by_id: $managed_by_id
      first: $first
      page: $page
      archived: false
    ) {
      data {
        id
        name
        currency
        booking_fee_amount
        charge_per_move_amount
        current_listings_count
        created_at
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
